import React from 'react';
import { Card, Grid, Header1Text, SmallBodyText, Header3Text, NavigationItem } from 'ui-toolkit';
import { faFileAlt } from '@fortawesome/pro-regular-svg-icons';
import { faEdit } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ClientUrlFactory } from '../../ui-toolkit/rest/ClientUrlFactory';
import { useSelector } from 'react-redux';
import { RootStore } from '../../store/types';
import { PrimaryHeader } from './styledComponents/PrimaryHeader';
import { eAccessControlUserType } from 'ui-toolkit/enums/eAccessControlUserType';
import { DateFormat, getDateString } from '../../ui-toolkit/utilities/getDateString';

interface ISearchReportBlockProps {
  orderId: string;
}

export const SearchReportBlock: React.FC<ISearchReportBlockProps> = ({ orderId }) => {
  const { titleReportExist } = useSelector((state: RootStore) => state.order.titleReport);
  const searchReportCreated = titleReportExist[orderId];

  if (!searchReportCreated) {
    return (
      <Card title={'Search Report and Title Commitment'}>
        <Grid templateColumns={'min-content'}>
          <NavigationItem
            intent={'primary'}
            appearance={'primary'}
            to={ClientUrlFactory().urlFor.searchReport(eAccessControlUserType.Vendor, orderId, 'create')}
            text={'Create'}
          />
        </Grid>
      </Card>
    );
  }

  return (
    <Card title={'Search Report and Title Commitment'}>
      <Grid templateColumns={'min-content 1fr min-content'} alignItems={'center'}>
        <Header1Text>
          <FontAwesomeIcon icon={faFileAlt} />
        </Header1Text>
        <div>
          <Header3Text>Search Report and Title Commitment</Header3Text>
          <SmallBodyText>Updated {getDateString(DateFormat.hugeDateTime, '')}</SmallBodyText>
        </div>
        <PrimaryHeader>
          <NavigationItem
            intent={'primary'}
            appearance={'default'}
            to={ClientUrlFactory().urlFor.searchReport(eAccessControlUserType.Vendor, orderId, 'edit')}
            text={''}
          >
            <FontAwesomeIcon icon={faEdit} />
          </NavigationItem>
        </PrimaryHeader>
      </Grid>
    </Card>
  );
};
